import { render, staticRenderFns } from "./MainType.vue?vue&type=template&id=0df88091&scoped=true&"
import script from "./MainType.vue?vue&type=script&lang=ts&"
export * from "./MainType.vue?vue&type=script&lang=ts&"
import style0 from "./MainType.vue?vue&type=style&index=0&id=0df88091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df88091",
  null
  
)

export default component.exports